var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"container",style:([_vm.elementStyles, _vm.basicContentStyles])},[_c('div',{style:([_vm.alignmentStyles, { textShadow: _vm.textShadow }])},[_c('span',{staticClass:"text",class:{
                  'newsticker': _vm.data.text_animation_type == 'newsticker',
                  'element-text-preview-transitions' : _vm.transitionText
              },style:([_vm.textStyles]),attrs:{"dir":_vm.direction}},[_vm._v(_vm._s(_vm.data.text_input))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }